import fetchFile from "../../utils/fetchFile";
import { DrawSVGPlugin, gsap } from "gsap/all";

const officesMap = async () => {
    const map = document.querySelector('#offices-map svg');
    const offices = {
        'mexico':       ['/wp-content/uploads/2024/10/Mexico.svg', 'https://maps.app.goo.gl/7NejkUdMTtFXtfkL6'],
        'madrid':       ['/wp-content/uploads/2024/10/Madrid.svg', 'https://maps.app.goo.gl/QvYFgttoUgYfSuWg7'],
        'malaga':       ['/wp-content/uploads/2024/10/Malaga.svg', 'https://maps.app.goo.gl/Ye6DnbwePZPZHSiG8'],
        'middle-east':  ['/wp-content/uploads/2024/10/Middle-East.svg'],
    };

    if( map ) {
        // Create the markers
        const markersPromise = await addMarkers();
        // After creation, animate the markers
        animateMarkers();
    }

    async function addMarkers() {
        return new Promise( (resolve, reject) => {
            let markerCount = 0;
            const totalMarkers = Object.keys(offices).length;
            // Place the corresponding markers in their place
            for( var office in offices ) {
                // Wrapping the async function fetchFile to avoid issues.
                (function(office) {
                    // Retrieves the svg path
                    let svg = offices[office][0];
                    let href = offices[office][1] ?? false;
                    
                    fetchFile( svg, (marker) => {
                        const markerEl = parseMarker(marker);
                        const officePos = getOfficePosition(office);
        
                        // Marker styling
                        markerEl.classList.add('marker');
                        markerEl.classList.add(`marker--${office}`);
                        markerEl.style.position = 'absolute';
                        markerEl.style.transformOrigin = 'bottom center';
                        markerEl.style.left = officePos.x;
                        markerEl.style.top = officePos.y;
                        markerEl.style.transform = 'translateY(-95%)';
                        
                        if( office == 'malaga' ) {
                            markerEl.style.transform = 'translateY(-5%)';
                        }
                        if( office == 'middle-east' ) {
                            markerEl.style.transform = 'translate(25.5%, -42%)';
                        }
                        
                        // Click function
                        if( href ){
                            markerEl.style.cursor = "pointer";
                            markerEl.addEventListener( 'click', () => {
                                window.open(href, '_blank');
                            } );
                        }
                        
                        map.parentElement.parentElement.appendChild(markerEl);

                        // Increment markerCount when a marker is added
                        markerCount++;

                        // If all markers have been added, resolve the promise
                        if (markerCount === totalMarkers) {
                            resolve();
                        }
                    } );
                })(office);
            }
        } );
    }

    /**
     * Returns as a node only the svg part needed to create the marker
     */
    function parseMarker( marker ) {
        // Transform the svg string to a node
        let markerEl = document.createElement('div');
        markerEl.innerHTML = marker;
        markerEl = markerEl.firstChild;

        return markerEl;
    }

    /**
     * Return the office coordinates inside the svg
     */
    function getOfficePosition( office ) {
        var elem = document.querySelector(`.${office}`);
        var svg = elem.ownerSVGElement;

        // Get the cx and cy coordinates
        var pt = svg.createSVGPoint();
        pt.x = elem.cx.baseVal.value;
        pt.y = elem.cy.baseVal.value;

        pt = getTransformToElement();

        return pt;

        function getTransformToElement() {
            while (true){
                // Get this elements transform
                var transform = elem.transform.baseVal.consolidate();
                // If it has a transform, then apply it to our point
                if (transform) {
                    var matrix = elem.transform.baseVal.consolidate().matrix;
                    pt = pt.matrixTransform(matrix);
                }
                // If this element's parent is the root SVG element, then stop
                if (elem.parentNode == svg) break;

                // Otherwise step up to the parent element and repeat the process
                elem = elem.parentNode;
            }
            return pt;
        }
    }

    /**
     * Animate the markers
     */
    function animateMarkers() {
        const circles = document.querySelectorAll('#offices-map .premium-svg-draw svg circle');
        const svgs = document.querySelectorAll('#offices-map svg.marker');

        circles?.forEach( (circle, i) => {
            const trigger = circle?.closest('div.e-parent');
            const animationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: trigger,
                    start: "top bottom",
                    end: "center bottom",
                    scrub: 1,   // Enable scrubbing for a smoother animation
                    // markers: true,

                    onEnter: () => {
                        // set the svg to 0 by default
                        gsap.to(circle, {
                            opacity: 0,
                            duration: 0, 
                        })
                    },
                    onLeave: (self) => {
                        gsap.to(circle, {
                            opacity: 1,
                            duration: 0.4,
                            delay: (i * 0.2), //adds more delay to further childs 
                        });
                        self.kill();
                    },
                }
            });
        } );
        svgs?.forEach( svg => {
            let path = svg.querySelector('path');
            let label = svg.querySelector('g');
            const trigger = svg?.closest('div.e-parent');
            let delay = circles ? (circles.length * 0.2) : (15 * 0.2) ;

            if( path && label ) {
                const animationTimeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: trigger,
                        start: "top bottom",
                        end: "center bottom",
                        scrub: 1,   // Enable scrubbing for a smoother animation
                        // markers: true,

                        onEnter: () => {
                            // set the svg to 0 by default
                            if( svg.classList.contains('marker--malaga') ) {
                                gsap.to(path, {
                                    drawSVG: "100% 100%", // Draw the malaga marker from the end
                                    duration: 0,
                                });
                            } else {
                                gsap.to(path, {
                                    drawSVG: "0% 0%",
                                    duration: 0,
                                });
                            }
                            gsap.to(label, {
                                opacity: 0,
                                duration: 0
                            });
                        },
                        onLeave: (self) => {
                            gsap.to(path, {
                                delay: delay,
                                drawSVG: "0% 100%",
                                duration: 3,
                            });
                            gsap.to(label, {
                                delay: delay + 1,
                                opacity: 1,
                                duration: 1,
                            });
                            self.kill();
                        },
                    }
                });
            }
        } );
    }
};
export default officesMap;